import './ImagesSlider.css';
import * as React from 'react';
import { IconButton } from 'office-ui-fabric-react';
import { Attachment } from '../../../../../../entities/Subentities';
import { ControlSpiner } from '../../../../Spinner';
import { IActions } from '../types';

type Props = {
    images: Attachment[];
    actions: IActions;
    contentHeight: number;
};

const MIN_HEIGHT = 150;

export const ImagesSlider = ({ images, actions, contentHeight }: Props) => {
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        if (currentIndex >= images.length) {
            setCurrentIndex(images.length - 1);
        }
    }, [images.length]);

    React.useEffect(() => {
        setIsLoading(true);
    }, [currentIndex]);

    const current = images[currentIndex];

    const height = contentHeight || MIN_HEIGHT;
    return (
        <ControlSpiner isLoading={isLoading} className='show-over' title=''>
            <div className='images-slider'>
                <div className='images-slider-content' style={{ height }}>
                    <img
                        height={height}
                        width="auto"
                        src={actions.getFileLink(current, true)}
                        alt={current?.attributes.Name}
                        onLoad={() => setIsLoading(false)}
                    />
                    <div className='images-slider-counter'>
                        {currentIndex + 1}/{images.length}
                    </div>
                    <IconButton
                        className='images-slider-button images-slider-button-previous'
                        iconProps={{ iconName: "ChevronLeft" }}
                        onClick={() => currentIndex > 0 && setCurrentIndex(currentIndex - 1)}
                    />
                    <IconButton
                        className='images-slider-button images-slider-button-next'
                        iconProps={{ iconName: "ChevronRight" }}
                        onClick={() => currentIndex < (images.length - 1) && setCurrentIndex(currentIndex + 1)}
                    />
                    <div className='images-slider-dots'>
                        {images.map((_, index) => (
                            <span
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className={`images-slider-dot ${_ === current ? 'active' : ''}`}
                                aria-hidden
                            />
                        ))}
                    </div>
                </div>
            </div>
        </ControlSpiner >
    );
};